import { assureToken } from 'authent365/utils/utils'

const api = {
  fetchPDF: (userType: UserType, pdfUrl: string) =>
    assureToken(userType).then((token) =>
      fetch(pdfUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          ContentType: 'blob',
        },
        method: 'GET',
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`Error fetching PDF: (HTTP error status ${response.status})`)
        }
        return response.blob().then(URL.createObjectURL)
      })
    ),
}

export default api
